export const ROLES = Object.freeze({
  SUPER_ADMIN: 'SuperAdmin',
  ADMIN: 'Admin',
  SUPER_ANALYTICS: 'SuperAnalytics',
  ANALYTICS: 'Analytics',
  FINANCE: 'Finance',
  EMPLOYEE: 'Employee',
  SUPER_FINANCE: 'SuperFinance',
  CUSTOMER_SUPPORT: 'CustomerSupport',
  EMPLOYER_JOB_REFERRALS: 'EmployerJobReferrals',
  PAYROLL_COORDINATOR: 'PayrollCoordinator',
  ORGANIZATION_ADMIN: 'OrganizationAdmin',
});

export const globalScopedRoles = Object.freeze([
  ROLES.SUPER_ADMIN,
  ROLES.SUPER_ANALYTICS,
  ROLES.SUPER_FINANCE,
  ROLES.CUSTOMER_SUPPORT,
]);

// Roles that are scoped to an organization (never to a company)
export const orgScopedRoles = [ROLES.ORGANIZATION_ADMIN];

export const rolesWithoutSuperRoles = [
  { label: ROLES.ADMIN, value: ROLES.ADMIN },
  { label: 'PayrollCoordinator', value: ROLES.PAYROLL_COORDINATOR },
  { label: 'OrganizationAdmin', value: ROLES.ORGANIZATION_ADMIN },
  { label: ROLES.ANALYTICS, value: ROLES.ANALYTICS },
  { label: ROLES.FINANCE, value: ROLES.FINANCE },
  { label: ROLES.EMPLOYEE, value: ROLES.EMPLOYEE },
  { label: ROLES.EMPLOYER_JOB_REFERRALS, value: ROLES.EMPLOYER_JOB_REFERRALS },
];

export const rolesWithoutSuperAdmin = [
  ...rolesWithoutSuperRoles,
  { label: ROLES.SUPER_ANALYTICS, value: ROLES.SUPER_ANALYTICS },
  { label: ROLES.SUPER_FINANCE, value: ROLES.SUPER_FINANCE },
  { label: ROLES.CUSTOMER_SUPPORT, value: ROLES.CUSTOMER_SUPPORT },
];

export const fullRolesList = [
  ...rolesWithoutSuperAdmin,
  { label: ROLES.SUPER_ADMIN, value: ROLES.SUPER_ADMIN },
];
